import api from "./index";
import { ENDPOINTS } from "./endpoints";

export const getCart = () => {
    return api.get(ENDPOINTS.CART.GET);
};

export const addToCart = (data) => {
    return api.post(ENDPOINTS.CART.ADD_ITEM, data);
};

export const removeCartItem = (variantId) => {
    const id = variantId?._id || variantId;
    return api.delete(ENDPOINTS.CART.REMOVE_ITEM(id));
};

export const updateCartItem = (variantId, data) => {
    const id = variantId?._id || variantId;
    return api.put(ENDPOINTS.CART.UPDATE_ITEM(id), data);
};

export const clearCart = () => {
    return api.delete(ENDPOINTS.CART.CLEAR);
};

export const validateCart = () => {
    return api.post(ENDPOINTS.CART.VALIDATE);
};
